/**
 * Single candidate table row for RoleCandidates page.
 */

import React from 'react';
import { CandidateEvaluation } from '../api/client';

interface CandidateRowProps {
  candidate: CandidateEvaluation;
  onViewResume: (resumeId: string) => void;
}

const getGradeColor = (grade: string) => {
  switch (grade) {
    case 'A': return '#059669';
    case 'B': return '#3b82f6';
    case 'C': return '#f59e0b';
    case 'D': return '#ef4444';
    default: return '#6b7280';
  }
};

const getRankDisplay = (rank: number) => {
  if (rank === 1) return '\u{1F947}';
  if (rank === 2) return '\u{1F948}';
  if (rank === 3) return '\u{1F949}';
  return `#${rank}`;
};

const CandidateRow: React.FC<CandidateRowProps> = ({ candidate, onViewResume }) => (
  <tr style={{ borderBottom: '1px solid #e5e7eb' }}>
    <td style={{ padding: '16px', textAlign: 'center', verticalAlign: 'middle' }}>
      <div style={{ fontSize: '18px', fontWeight: 600 }}>
        {getRankDisplay(candidate.rank)}
      </div>
    </td>
    <td style={{ padding: '16px', verticalAlign: 'middle' }}>
      <div style={{ fontWeight: 600, color: '#1f2937' }}>
        {candidate.full_name || 'Unknown'}
      </div>
    </td>
    <td style={{ padding: '16px', verticalAlign: 'middle' }}>
      <div style={{ fontSize: '14px', color: '#6b7280' }}>
        {candidate.email && <div>{candidate.email}</div>}
        {candidate.phone && <div>{candidate.phone}</div>}
      </div>
    </td>
    <td style={{ padding: '16px', textAlign: 'center', verticalAlign: 'middle' }}>
      <div style={{ fontSize: '18px', fontWeight: 600, color: '#1f2937' }}>
        {candidate.score.toFixed(1)}
      </div>
    </td>
    <td style={{ padding: '16px', textAlign: 'center', verticalAlign: 'middle' }}>
      <div style={{
        display: 'inline-block',
        padding: '6px 12px',
        borderRadius: '12px',
        fontSize: '14px',
        fontWeight: 700,
        color: 'white',
        backgroundColor: getGradeColor(candidate.letter_grade)
      }}>
        {candidate.letter_grade}
      </div>
    </td>
    <td style={{ padding: '16px', textAlign: 'center', verticalAlign: 'middle' }}>
      {candidate.requires_manual_review && (
        <span style={{
          padding: '4px 8px',
          background: '#fef3c7',
          color: '#92400e',
          borderRadius: '6px',
          fontSize: '12px',
          fontWeight: 600
        }}>
          Review
        </span>
      )}
    </td>
    <td style={{ padding: '16px', textAlign: 'right', verticalAlign: 'middle' }}>
      <button
        onClick={() => onViewResume(candidate.resume_id)}
        style={{
          padding: '8px 14px',
          background: '#2d5016',
          color: 'white',
          border: 'none',
          borderRadius: '6px',
          fontSize: '13px',
          fontWeight: 600,
          cursor: 'pointer',
          transition: 'all 0.2s',
          whiteSpace: 'nowrap'
        }}
        onMouseEnter={(e) => e.currentTarget.style.background = '#3d6b1f'}
        onMouseLeave={(e) => e.currentTarget.style.background = '#2d5016'}
      >
        View Resume
      </button>
    </td>
  </tr>
);

export default CandidateRow;
